import api from '../axios/axiosConfig';

import { cuponErrorMsgMap } from '../features/coupons/Coupons';

export const getChargerStations = async (stationId: string) => {
  try {
    const response = await api.get(`/SiteConnectors/${stationId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar stattion de carregamento', error);
    throw error;
  }
};

export const postStartCharging = async (
  chargerId: string,
  connectorId: string,
  selectedVehicle?: string | null,
  selectedCoupon?: string | null
): Promise<{ [key: string]: string }> => {
  try {
    const response = await api.post(
      `/RemoteStartTransactionRequest`,
      {
        ChargePointID: `${chargerId}-${connectorId}`,
        uvId: selectedVehicle,
        udcId: selectedCoupon,
      },
      { timeout: 15000 }
    );
    let errorMsg;
    if (
      cuponErrorMsgMap &&
      response?.data?.info &&
      cuponErrorMsgMap.hasOwnProperty(response.data.info)
    ) {
      errorMsg = cuponErrorMsgMap[response.data.info];
    }
    return errorMsg ? { status: 'Error', info: errorMsg } : response.data;
  } catch (error: any) {
    console.error('Erro ao iniciar recarga', error);
    return { status: 'TimedOut' };
  }
};

export const postStopCharging = async (
  chargerId: string,
  connectorId: string,
  transactionId: string
) => {
  try {
    const response = await api.post(
      `/RemoteStopTransactionRequest`,
      {
        ChargePointID: `${chargerId}-${connectorId}`,
        TransactionID: transactionId,
      },
      { timeout: 10000 }
    );
    return response.data;
  } catch (error) {
    console.error('Erro ao parar recarga', error);
    throw error;
  }
};

export const getCurrentPriceProfilePeriod = async (chargepointid: string) => {
  try {
    const response = await api.get(
      `/CurrentPriceProfilePeriod/${chargepointid}`
    );
    return response.data;
  } catch (error) {
    console.error('Erro ao parar recarga', error);
    throw error;
  }
};
